import {connect} from 'react-redux';
import BiometricsDeactivateFingerprintsCaptureView
    from '../../components/views/mx/BiometricsDeactivateFingerprintsCaptureView';
import * as BiometricsDataStepActions from '../../actions/mx/BiometricsDataStepActions';
import {State} from '../../../../types/mx/reducers';
import {
    BiometricsResetStateProps,
    BiometricsResetDispatchProps,
} from '../../types/mx/containers';
import * as ModalActions from '../../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';

const mapStateToProps = (state: State): BiometricsResetStateProps => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): BiometricsResetDispatchProps => {
    return {
        onPressResetConfirm: () => {
            dispatch(BiometricsDataStepActions.BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const BiometricsDeactivateFingerprintsCaptureContainer = connect(
    mapStateToProps, mapDispatchToProps,
)(BiometricsDeactivateFingerprintsCaptureView);

export default BiometricsDeactivateFingerprintsCaptureContainer;
